import BoxedSelector from "./styles/BoxedSelector";
import { YearNotFitInModel } from "./YearNotFitInModel";

interface IProps {
  formView: "horizontalView" | "verticalView";
  dropdownOpenFromRight?: boolean;
  newStyles?: boolean;
  isHorizontalVehicleSelector?: boolean;
}

function BoxedVehicleSelector(props: IProps) {
  const {
    dropdownOpenFromRight, newStyles, formView, isHorizontalVehicleSelector,
  } = props;
  // const [_selectionOrder, setSelectionOrder] = useState(selectionOrder);

  // const [updatedDefaultVehicle, setUpdatedDefaultVehicle] = useState({
  //   defaultMake,
  //   defaultModel,
  //   defaultYear,
  // });

  // function yearNotFitInModelHandler(params) {
  //   const { selectedYear } = params;
  //   updatedDefaultVehicle.defaultModel = null;
  //   updatedDefaultVehicle.defaultYear = selectedYear;
  //   setUpdatedDefaultVehicle({
  //     defaultMake,
  //     defaultYear: selectedYear,
  //     defaultModel: null,
  //   });
  //   setSelectionOrder(MAKE_YEAR_MODEL);
  // }

  return (
    <BoxedSelector
      dropdownOpenFromRight={dropdownOpenFromRight}
      newStyles={newStyles}
      formView={formView}
      isHorizontalVehicleSelector={isHorizontalVehicleSelector}
    >
      <YearNotFitInModel {...props} />
    </BoxedSelector>
  );
}

export default BoxedVehicleSelector;
